import { SVGProps, Ref, forwardRef } from 'react';

export const BookFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 3.17C.75 1.728 0 2.319 0 7.896v4.249c0 5.577.75 6.58 6 8.023 1.682.462 3.396.776 5.1 1.14V4.762C9.404 4.22 7.716 3.643 6 3.17m6.9 1.59v16.548c1.702-.365 3.42-.68 5.1-1.14 5.25-1.444 6-2.447 6-8.024v-4.25c0-5.576-.75-6.167-6-4.723-1.716.472-3.404 1.05-5.1 1.59"
                fill="currentColor"
            />
        </g>
    </svg>
));
BookFilledSize24Glyph.displayName = 'BookFilledSize24Glyph';
